<template>
  <nav class="menu-container">
    <h3><font color="#3ABCA8">6号线</font></h3>
    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
  </nav>
</template>

<script>
import Icon from "@/components/Icon";
export default {
  components: {
    Icon,
  },
  data() {
    return {
      items: [
        {
          name: "kexueguan",
          title: "科学馆",
          // icon: "chat",
          exact: true,
        },
        {
          name: "tongxinling",
          title: "通新岭",
          // icon: "chat",
          exact: true,
        },
        {
          name: "tiyuzhongxin",
          title: "体育中心",
          // icon: "chat",
          exact: true,
        },
        {
          name: "bagualing",
          title: "八卦岭",
          // icon: "chat",
          exact: true,
        },
        {
          name: "yinhu",
          title: "银湖",
          // icon: "chat",
          exact: true,
        },
        {
          name: "hanling",
          title: "翰岭",
          // icon: "chat",
          exact: true,
        },
        {
          name: "meilinguan",
          title: "梅林关",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shenzhenbei",
          title: "深圳北",
          // icon: "chat",
          exact: true,
        },
        {
          name: "hongshan",
          title: "红山",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shangfen",
          title: "上芬",
          // icon: "chat",
          exact: true,
        },
        {
          name: "yuanfen",
          title: "元芬",
          // icon: "chat",
          exact: true,
        },
        {
          name: "yangtaishandong",
          title: "阳台山东",
          // icon: "chat",
          exact: true,
        },
        {
          name: "guantian",
          title: "官田",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shangwu",
          title: "上屋",
          // icon: "chat",
          exact: true,
        },
        {
          name: "changzhen",
          title: "长圳",
          // icon: "chat",
          exact: true,
        },
        {
          name: "fenghuangcheng",
          title: "凤凰城",
          // icon: "chat",
          exact: true,
        },
        {
          name: "guangmingdajie",
          title: "光明大街",
          // icon: "chat",
          exact: true,
        },
        {
          name: "guangming",
          title: "光明",
          // icon: "chat",
          exact: true,
        },
        {
          name: "kexuegongyuan",
          title: "科学公园",
          // icon: "chat",
          exact: true,
        },
        {
          name: "loucun",
          title: "楼村",
          // icon: "chat",
          exact: true,
        },
        {
          name: "honghuashan",
          title: "红花山",
          // icon: "chat",
          exact: true,
        },
        {
          name: "gongmingguangchang",
          title: "公明广场",
          // icon: "chat",
          exact: true,
        },
        {
          name: "heshuikou",
          title: "合水口",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shutianpu",
          title: "薯田埔",
          // icon: "chat",
          exact: true,
        },
        {
          name: "songganggongyuan",
          title: "松岗公园",
          // icon: "chat",
          exact: true,
        },
        {
          name: "xitou",
          title: "溪头",
          // icon: "chat",
          exact: true,
        },
        {
          name: "songgang",
          title: "松岗",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(67, 47, 221);
    }
  }
}
</style>





<!-- <template>
  <div>
    <h3>
        首页<br><br>
深圳地铁1号线 途经站点 共30站<br><br>
注：高峰期发车间隔为4分钟，平峰期为6分钟<br><br>

罗湖站-国贸站-老街站-大剧院站-科学馆站-华强路站-岗厦站-会展中心站-购物公园站-香蜜湖站-车公庙站-竹子林站-侨城东站-华侨城站-世界之窗站-白石洲站-高新园站-深大站-桃园站-大新站-鲤鱼门站-前海湾站-新安站-宝安中心站- 宝体站-坪洲站-西乡站-固戍站-后瑞站-机场东站
    </h3>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style> -->